import { render, staticRenderFns } from "./ResourcesBDialog.vue?vue&type=template&id=7c5a6f10"
import script from "./ResourcesBDialog.vue?vue&type=script&lang=js"
export * from "./ResourcesBDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports